
import React, { useEffect, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import InputSelect from '../components/InputSelect'
import useTranslation from '../../../Hooks/UseTranslation'
import { useDispatch } from 'react-redux'
import { updateTaskParentIdAction } from '../../../Redux/Actions/ProgrammationManagerActions'
import { getGroupOptionsFromTaskList } from '../../../Helpers/TasksHelper'
import { useProgrammation } from '../../../Hooks/UseProgrammation'
import { updateTaskParentId } from '../../../Services/ProgrammationManagerService'

interface Props {
  task: any
  taskList: any[]
}

const TaskGroup = ({ task, taskList }: Props) => {

  const { t } = useTranslation()

  const { setEditingItem } = useProgrammation()

  const dispatch = useDispatch()

  const [ groupId, setGroupId ] = useState(task.groupId || '')
  const [ groupsOptions, setGroupsOptions ] = useState<any[]>([])

  const handleChangeGroupId = async (groupId: string) => {

    setGroupId(groupId)

    setEditingItem(true)

    const [error, data] = await updateTaskParentId(task._id, groupId, task.project)

    setEditingItem(false)
    if (error) {
      return;
    }

    await dispatch(updateTaskParentIdAction(data))

  }

  useEffect(() => {

    const groupsOptions = getGroupOptionsFromTaskList(taskList, 0)
    setGroupsOptions(groupsOptions)

  }, [taskList])

  return (
    <Form.Group>
      <Form.Label>
        {t('PROGRAMMATION_MANAGER:GroupLabel')}
      </Form.Label>
      <Row>
        <Col>
          <InputSelect
            value={groupId}
            onChange={handleChangeGroupId}
            placeholder={t('PROGRAMMATION_MANAGER:SelectPlaceholder')}
            options={groupsOptions}
            renderOption={(option: any) => (
              <option value={option.value}>
                {option.label}
              </option>
            )}
          />
        </Col>
      </Row>
    </Form.Group>
  )
}

export default TaskGroup
